import { render, staticRenderFns } from "./Epicentral.vue?vue&type=template&id=06d40b86&scoped=true"
import script from "./Epicentral.vue?vue&type=script&lang=js"
export * from "./Epicentral.vue?vue&type=script&lang=js"
import style0 from "./Epicentral.vue?vue&type=style&index=0&id=06d40b86&prod&lang=scss&scoped=true"
import style1 from "./Epicentral.vue?vue&type=style&index=1&id=06d40b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d40b86",
  null
  
)

export default component.exports